import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../axiosAuth";
import { ACCESS_API } from "./apiRoutes";

const mutateUpdatePermission = async ({
  communityId,
  data,
}: {
  communityId: string;
  data: FieldValues;
}) => {
  return await axiosAuth.put(`${ACCESS_API}/community/${communityId}`, data);
};

const useUpdatePermissionMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      communityId: string;
      data: FieldValues;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateUpdatePermission,
    ...queryParams,
  });

export default useUpdatePermissionMutation;
